<template>
  <div class="product-add">

    <el-form size="small" ref="formData" :model="formData" label-width="200px">

      <el-form-item label="分享文章得积分" prop="share_article_point">
        <el-input type='number' v-model="formData.share_article_point" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="视频奖励设置：">
        <div >
          <el-table
            :data="formData.gradeList"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="会员等级">
            </el-table-column>

            <el-table-column
              prop="video_type"
              label="奖励类型">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-radio-group  v-model="scope.row.video_type">
                    <el-radio :label="0">固定</el-radio>
                    <el-radio :label="1">随机</el-radio>
                  </el-radio-group>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="video_name"
              label="金额">
              <template v-slot="scope">
                <div class="d-s-c">
                  <span v-if="scope.row.video_type">最高数额</span>
                  <el-input v-model="scope.row.video_value"  min="0"  type="number" placeholder="请输入金额"></el-input>
                  <span class="ml10">元</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="video_limit"
              label="每天数量">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.video_limit" min="0" type="number" placeholder="每天数量"></el-input>
                  <span class="ml10">个</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>


      <!--提交-->
      <div>
        <el-button size="small" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import ArticleApi from '@/api/article.js';
export default {
  data() {
    return {
      /*form表单数据*/
      formData: {
        share_article_point: 0,
        gradeList:[],
      }
    };
  },
  created() {
    this.getData();
  },

  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      ArticleApi.settingDetail({}, true)
        .then(data => {
          if(data.data.values!=[]){
            console.log(data.data.values);
            if(data.data.values!=[]){
              if (data.data.values.gradeSetting != '' && typeof data.data.values.gradeSetting != 'undefined') {
                let equitys = data.data.values.gradeSetting;
                data.data.gradeList.forEach(item => {
                  item.video_type = equitys[item.grade_id]? equitys[item.grade_id].video_type :0;
                  item.video_value =equitys[item.grade_id]? equitys[item.grade_id].video_value:0;
                  item.video_limit =equitys[item.grade_id]? equitys[item.grade_id].video_limit:0;
                });
              }
              self.formData = data.data.values;
              self.formData.gradeList = data.data.gradeList;

            }
          }

        })
        .catch(error => {});
    },
    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};
      list.forEach(item => {
        obj[item.grade_id] = {
          'video_type':item.video_type,
          'video_value':item.video_value,
          'video_limit':item.video_limit,
        }
      });

      return obj;
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      let gradeSetting={};
      params.share_article_point = self.formData.share_article_point;
      self.formData.gradeList.forEach(item => {
        gradeSetting[item.grade_id] = {
          'video_type':item.video_type,
          'video_value':item.video_value,
          'video_limit':item.video_limit,
        }
      });
      params.gradeSetting = gradeSetting;
      ArticleApi.editSetting(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/article/setting/setting.vue